import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { Plus, X, Check } from 'lucide-react';

const norm = s => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export const DesiredFeaturesPicker = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState('');
  const selected = value || [];

  useEffect(() => { api.get('/crm/desired-features').then(setOptions).catch(() => {}); }, []);

  const toggle = opt => {
    const on = selected.some(s => norm(s) === norm(opt));
    onChange(on ? selected.filter(s => norm(s) !== norm(opt)) : [...selected, opt]);
  };

  const create = async () => {
    const n = name.trim();
    if (!n) return;
    try {
      const res = await api.post('/crm/desired-features', { name: n });
      if (!options.some(o => norm(o) === norm(res.name))) setOptions(prev => [...prev, res.name].sort((a, b) => norm(a).localeCompare(norm(b))));
      if (!selected.some(s => norm(s) === norm(res.name))) onChange([...selected, res.name]);
      setName(''); setAdding(false);
    } catch { toast.error('No se pudo crear la característica'); }
  };

  const all = [...options, ...selected.filter(s => !options.some(o => norm(o) === norm(s)))];
  return (
    <div data-testid="desired-features-picker" className="flex flex-wrap gap-2">
      {all.map(opt => {
        const on = selected.some(s => norm(s) === norm(opt));
        return (
          <button type="button" key={opt} onClick={() => toggle(opt)} data-testid={`desired-feature-${norm(opt).replace(/\s+/g, '-')}`}
            className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-xs border transition-colors ${on ? 'bg-[#A38560] border-[#A38560] text-[#03110D] font-semibold' : 'bg-[#0A1F1A] border-[#1A3B32] text-white/60 hover:text-white hover:border-[#A38560]/50'}`}>
            {on && <Check size={12} />}{opt}
          </button>
        );
      })}
      {adding ? (
        <div className="flex items-center gap-1">
          <input value={name} onChange={e => setName(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); create(); } }} autoFocus
            placeholder="Nueva característica..." data-testid="desired-feature-new-input"
            className="bg-[#0A1F1A] border border-[#1A3B32] text-white text-xs rounded-full px-3 py-1.5 w-44 focus:outline-none focus:border-[#A38560]" />
          <button type="button" onClick={create} data-testid="desired-feature-new-save" className="p-1.5 rounded-full bg-[#6BCB77]/20 text-[#6BCB77]"><Check size={12} /></button>
          <button type="button" onClick={() => { setAdding(false); setName(''); }} className="p-1.5 rounded-full bg-red-400/10 text-red-400"><X size={12} /></button>
        </div>
      ) : (
        <button type="button" onClick={() => setAdding(true)} data-testid="desired-feature-add-btn"
          className="flex items-center gap-1 px-3 py-1.5 rounded-full text-xs border border-dashed border-white/20 text-white/50 hover:text-white hover:border-[#A38560]">
          <Plus size={12} />Crear otra
        </button>
      )}
    </div>
  );
};
